import * as firebase from 'firebase/app';

import 'firebase/analytics';
import 'firebase/storage';
import 'firebase/database';

const firebaseConfig = {
  apiKey: 'AIzaSyBFyvEhPgMRhmKlsnZLlY83h0Gu_0FATZ8',
  authDomain: 'cloud-a2d2c.firebaseapp.com',
  databaseURL: 'https://cloud-a2d2c.firebaseio.com',
  projectId: 'cloud-a2d2c',
  storageBucket: 'cloud-a2d2c.appspot.com',
  messagingSenderId: '736199807738',
  appId: '1:736199807738:web:c5943e083930c656eaef43',
  measurementId: 'G-HXKZQ24Q1B',
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

export const storage = firebase.storage();
export const database = firebase.database();
